module.exports = __webpack_public_path__ + "static/media/ic_add_circle_24px.1432ebe8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_add_circle_24px.svg
// module id = 1058
// module chunks = 0